import React, { useState, useEffect, useRef } from 'react'
import "../../../App";
import moment from 'moment';
import { Loading, Modal, InlineNotification, Button } from 'carbon-components-react';
import IncidentDetailsForm from 'components/IncidentDetails/IncidentDetailsPage/IncidentDetailsForm';
import axios from "axios";
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import * as IncidentDetailsUtil from '../IncidentDetailsUtil.js';
import queryString from 'query-string';
import i18n from "../../../i18n";
import { Idea32 } from '@carbon/icons-react';
import * as workspaces from '../../../config/WorkspaceConstants';
import callPostApiWithoutConfigURl from '../../../requests/PostRequestsWithoutConfigUrl';
import InsightsModal from '../../ManageAutomationPage/Insights/InsightsModal';
import * as InsightsData from '../../ManageAutomationPage/Insights/InsightsMockData';
import * as configConst from "../../../config/Constants"

require("./_incidentDetailsPage.scss");
var config = require('../../../config/appConfig.json');

const IncidentDetailsPage = (props) => {
	const [incidentDetailsData, setIncidentDetailsData] = useState();
	const [incidentDetailsLoading, setIncidentDetailsLoading] = useState();
	const [disableIncidentUpdate, setDisableIncidentUpdate] = useState(false);
	const [incidentUpdateLoading, setIncidentUpdateLoading] = useState(false);
	const [showIncidentUpdateModal, setShowIncidentUpdateModal] = useState(false);
    const [showInsightModal, setShowInsightModal] = useState(false);
	const [updateIncidentStatusMessage, setUpdateIncidentStatusMessage] = useState();
	const [sysId, setSysId] = useState();
	const [workspace, setWorkspace] = useState();
	const [client, setClient] = useState();
	const [incidentId, setIncidentId] = useState();
	const [alertType, setAlertType] = useState();
	const [notifyResolve, setNotifyResolve] = useState(false);
	const [classificationData, setClassificationData] = useState();
    const [CarouselIndex, setCarouselIndex] = useState(0);
    const [insightsData, setInsightsData] = useState([]);
    const [insightsTableData, setInsightsTableData] = useState([]);
    const [insightsDataLoading, setInsightsDataLoading] = useState(false);
    const [insightsCount, setInsightsCount] = useState(0);
    const [clientsByUserAccess, setClientsByUserAccess] = useState([]);
    //const [reasonError, setReasonError] = useState(false);
    //const [isReasonDropdownShown, setIsReasonDropdownShown] = useState(false);
    //const [reasonToUpdate, setReasonToUpdate] = useState();
    const [incidentDetailsDataForCompare, setIncidentDetailsDataForCompare] = useState();

    const [applicationName, setApplicationName] = useState();
    const [createdAt, setCreatedAt] = useState();
    const [userName, setUserName] = useState();
    const[queue, setQueue] = useState(false);
    const[incidentQueue, setIncidentQueue] = useState(false);
    const[queueName, setQueueName] = useState('');
    const[appHostMachineName, setAppHostMAchineName] = useState('');
    

    const IncidentUpdated= i18n.t('IncidentDetails.IncidentUpdated');
    const InsufficientPriviledge= i18n.t('IncidentDetails.InsufficientPriviledge');
    const SomethingWentWrongError = i18n.t('IncidentDetails.SomethingWentWrongError');
    const Mandatoryfields = i18n.t('IncidentDetails.Mandatoryfields');
    const Insights = i18n.t('manageAutomation.Insights');
    const SeeAll = i18n.t('manageAutomation.SeeAll');
	let user = JSON.parse(localStorage.getItem('user_name'))
    let userID = JSON.parse(localStorage.getItem('user'));

    const UpdateReason = useRef('');
	useEffect(() => {

		let params = queryString.parse(props.location.search);
        console.log("params",params);
		setSysId(params.sysId);
		setWorkspace(params.workspace);
		setClient(params.client);
		setIncidentId(params.incidentId);
		setAlertType(params.alertType);
        setApplicationName(params.applicationName);
        setCreatedAt(params.createdAt);
        setQueue(params.isQueue);
        setIncidentQueue(params.incidentQueue);
        setQueueName(params.queueName);
        setAppHostMAchineName(params.appHostName);
        
        //setUserName(user.username);
		if (sysId && workspace && client && incidentId && alertType) {
			fetchIncidentDetailsFromElasticAndITSM();
           //createdAt && getInsightData(); //
		} 
    }, [sysId, workspace, client, incidentId, alertType]);

  
    // useEffect(() => {
    //     getClientsByUserAccess();
    // }, []);

    //uncomment for insights section Start
    // useEffect(() => {
    //     if (applicationName && createdAt) {
    //         applicationName && createdAt && getInsightData();
    //     }
    // }, [applicationName, createdAt, clientsByUserAccess]); 

    // const CHECK_INTERVAL = 60000 * 5 //5 minutes;
    // useEffect(() => {
    //     let id = setInterval(() => {
    //         getInsightData();
    //         console.log("called getInsightData function")
    //     }, CHECK_INTERVAL);
    //     return () => clearInterval(id);
    // });

    // useEffect(() => {
    //     if (insightsData.length > 0) {
    //         setInsightsCount(insightsData.length);
    //     }
    // }, [insightsData]);

    // useEffect(() => {
    //     if (insightsData.length > 0 && showInsightModal === true) {
    //         getAcknowledgeData(insightsData[0])
    //     }
    // }, [insightsData, showInsightModal]);
    
    // useEffect(() => {
    //     if (showInsightModal === true) {
    //         const insightsDataNotif = [...insightsData];
    //         if (insightsData.length > 0) {
    //             insightsData[0]['seen'] = true;
    //         }
    //         setInsightsData(insightsDataNotif)
    //     }
    // }, [showInsightModal]);

    //uncomment for insights section End


    function getClientsByUserAccess() {
        callPostApi(Constants.GETUNIQUECLIENTS, {
            'Content-Type': 'application/json'
        })
            .then(resp => {
                let clients = resp.map(client => client.key);
                setClientsByUserAccess(clients);
                console.log(clients, "clients 12");
            }).catch((error) => {
            })
    }

    const handleInsightsUpdate = (state, value) => {
        switch (state) {
            case 'CorousalData':
                setInsightsData(value);
                break;
            case 'CorousalDataCount':
                setInsightsCount(value);
                break;
            default:
        }
    }
    const getAcknowledgeData = (data) => {
        let bodyJSON = {
            "documentId": data.documentId,
            "userId": userID.username
        }
        if (data.isAcknowledged === false) {
            callPostApiWithoutConfigURl(Constants.UPDATEINSIGHTS, {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ZG91c2VyOkRAcHcwMDlrczEyOUg=',
            }, bodyJSON).then(resp => {
            }).catch((error) => {
                console.error('Error:', error);
            });
        }
    };

    const handleCarouselSelect = (selectedIndex, e) => {
        insightsData.length > 0 && getAcknowledgeData(insightsData[selectedIndex]);
        let insightsDataNotification = [...insightsData];
        for (let i = 0; i <= insightsData.length; i++) {
            if (insightsData[selectedIndex]) {
                insightsData[selectedIndex].seen = true;
            }
        }
        //insightsData.splice(selectedIndex - 1, 1);
        setInsightsData(insightsDataNotification);
        setCarouselIndex(selectedIndex);
        console.log(insightsCount, "insightsCount", selectedIndex, e);
        //console.log("eventvalue", e);
        // if (insightsCount) {
        //     decreaseInsightsCount(selectedIndex);
        // }
    };

    const getInsightData = () => {
        setInsightsDataLoading(true);
        let formattedData = [];
        //console.log(incidentDetailsData, "incidentDetailsData")
        let data = {
            "userId": userID.username,
            "clientname": "DEVSECOPS",
            //"clientname": clientsByUserAccess,
            "appname": applicationName,
            //"appname": "Devops commander",
            "createdtime": createdAt
        };
        callPostApiWithoutConfigURl(Constants.GETINSIGHTS, {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ZG91c2VyOkRAcHcwMDlrczEyOUg=',
        }, data)
            .then(resp => {
                //formattedData = prepareInsightData(InsightsData.InsightsCarouselData);
                formattedData = prepareInsightData(resp);
                setInsightsData(formattedData.carouselData);
                setInsightsTableData(formattedData.tableData);
                setInsightsDataLoading(false);
            }).catch((error) => {
                setInsightsDataLoading(false);
            });
    }

    const prepareInsightData = (response) => {

        let tableData = [];
        let tableObj = {};
        let carouselData = [];
        let carouselObj = {};

        if (response) {
            let bucket = response;
            for (let i = 0; i < bucket.length; i++) {
                tableObj = {
                    id: (i + 1).toString(),
                    name: bucket[i]._source.sonar_message.Application_Name,
                    client: bucket[i]._source.sonar_message.Engagement.name,
                    details: bucket[i]._source.sonar_message.Error_description,
                    documentId: bucket[i]._id,
                    acknowledged: bucket[i]._source.acknowledged[0] ? bucket[i]._source.acknowledged[0] : "",
                    date: moment(bucket[i]._source.sonar_message.Error_date).format('lll'),
                    error_title: bucket[i]._source.sonar_message.Error_message
                }
                carouselObj = {
                    id: (i + 1).toString(),
                    name: bucket[i]._source.sonar_message.Application_Name,
                    client: bucket[i]._source.sonar_message.Engagement.name,
                    details: bucket[i]._source.sonar_message.Error_description,
                    documentId: bucket[i]._id,
                    acknowledged: bucket[i]._source.acknowledged,
                    date: moment(bucket[i]._source.sonar_message.Error_date).format('lll'),
                    error_title: bucket[i]._source.sonar_message.Error_message,
                    isAcknowledged: false //default value
                }
                let acknowledgedBucket = bucket[i]._source.acknowledged ? bucket[i]._source.acknowledged : [""];
                for (let j = 0; j < acknowledgedBucket.length; j++) {
                    if (acknowledgedBucket[j] === userID.username) {
                        carouselObj.isAcknowledged = true;
                    }
                }
                tableData.push(tableObj);
                carouselData.push(carouselObj);
            }
        }
        carouselData = carouselData.filter(value => (value.isAcknowledged === false));
        return { tableData, carouselData };
    };

	async function fetchIncidentDetailsFromElasticAndITSM() {
		setIncidentDetailsLoading(true);
		const [incidentDetailsResponse, customFieldsResponse] = await Promise.all([
			getIncidentDetails(),
			getIncidentDetailsForCustomFields()
		]);
		let formattedData = prepareIncidentDetailsData(incidentDetailsResponse, customFieldsResponse);
		setIncidentDetailsData(formattedData);
        setIncidentDetailsDataForCompare({...formattedData});
		setIncidentDetailsLoading(false);
	};

	const notifyResolveError = () => {
		setNotifyResolve(!notifyResolve)
	  }
    // const notifyReasonError = () => {
    //     setReasonError(!reasonError);
    // }

    // const handleIsReasonDropdownShown = (bool) => {
    //     setIsReasonDropdownShown(bool);
    // }

	const getFormattedTime = (date) => {
		let formattedDate = '';
		let offset;
		if (date) {
			offset = moment(date).utcOffset();
			formattedDate = moment.utc(date).utcOffset(offset).format('YYYY-MM-DD HH:mm');
		}
		return formattedDate;
	};

	const prepareIncidentDetailsData = (incidentDetailsResponse, customFieldsResponse) => {
		if (incidentDetailsResponse && incidentDetailsResponse.data) {
			incidentDetailsResponse = incidentDetailsResponse.data;
		}
		customFieldsResponse = customFieldsResponse.hits.hits[0];
		let incidentDetails = { ...incidentDetailsResponse, ...customFieldsResponse };
		let formattedData = {};
		if (incidentDetails) {
			formattedData.sys_id = incidentDetails.sysId;
			formattedData.number = incidentDetails.incident_id;
			formattedData.state = { 'label': incidentDetails.status, 'id': '' };
			formattedData.caller_id = incidentDetails.caller_id ? incidentDetails.caller_id : '';
			formattedData.contact_type = { 'label': incidentDetails.contact_type, 'id': '' };
			formattedData.assigned_to = { 'label': incidentDetails.assigned_to ? incidentDetails.assigned_to : '', 'id': '' };
			formattedData.assignment_group = { 'label': incidentDetails.assignment_group ? incidentDetails.assignment_group : '', 'id': '' };
			formattedData.category = { 'label': incidentDetails.category, 'id': '' };
			formattedData.subcategory = { 'label': incidentDetails.subcategory, 'id': '' };
			formattedData.business_service = incidentDetails.business_service;
			formattedData.impact = { 'label': incidentDetails.impact, 'id': '' };
			formattedData.urgency = { 'label': incidentDetails.urgency, 'id': '' };
			formattedData.priority = incidentDetails.priority;
			formattedData.cmdb_ci = incidentDetails.cmdb_ci;
			formattedData.short_description = incidentDetails.short_description;
			formattedData.description = incidentDetails.description;
			formattedData.comments_and_work_notes = incidentDetails.comments_and_work_notes;
			formattedData.resolvedBySOC = { 'label': incidentDetails.can_be_resolved_by_soc, 'id': '' };
			formattedData.actionTakenBySOC = { 'label': incidentDetails.action_taken_by_soc, 'id': '' };
			//formattedData.reasonsToUpgradeDowngrade = { 'label': incidentDetails.u_reason_upgrade ? incidentDetails.u_reason_upgrade : '', 'id': '' };
			//formattedData.reasonsToUpgrade = { 'label': incidentDetails.priority_upgrade_reason ? incidentDetails.priority_upgrade_reason : '', 'id': '' };
			//formattedData.reasonsToDowngrade = { 'label': incidentDetails.priority_downgrade_reason ? incidentDetails.priority_downgrade_reason : '', 'id': '' };



			if (workspace !== workspaces.sap_ops && incidentDetails._source && workspace !== workspaces.custom_ops && workspace !== workspaces.salesforce_ops) {

				if(alertType === "Dependency failure" ||  alertType === "Long running"  || alertType === "Long pending" ){
					/* Fields only for Automation */
				formattedData.u_app_host_machine_name = incidentDetails._source.appHostMachineName;
				/* Fields only for Automation */
				formattedData.creationTime = getFormattedTime(incidentDetails._source.alert_created_at); //automata_create_time
				formattedData.u_jobid = incidentDetails._source.job_id;
				formattedData.u_client = incidentDetails._source.party_name;
				formattedData.u_technology = incidentDetails._source.technology; 
				formattedData.u_process_id = incidentDetails._source.ProcessId;  
				formattedData.franchise = incidentDetails._source.acc_type_name;
				formattedData.sysTime = getFormattedTime(incidentDetails._source.last_updated_at); // check last_update_time
				if (alertType === "Dependency failure") {
					formattedData.u_resource = incidentDetails._source.source_name;
					formattedData.ticketingToolPath = incidentDetails.incident_url;
					formattedData.sys_id = incidentDetails.sys_id;
				} else {
					formattedData.u_resource = incidentDetails._source.automata_exe_resource;
					formattedData.ticketingToolPath = incidentDetails._source.incident_url;
					formattedData.sys_id = incidentDetails._source.incident_sys_id;
				}
				

				}else if(alertType === "Infra-alert-automation"){
                    console.log("Infra-alert-automation");
					formattedData.ticketingToolPath = incidentDetails._source.incident.url;
					formattedData.franchise = incidentDetails._source.metadata.accType;
					formattedData.u_client = incidentDetails._source.metadata.clientId;
					formattedData.u_jobid = incidentDetails._source.remediation.jobId;
					formattedData.sysTime = getFormattedTime(incidentDetails._source.incident.lastUpdtTime);

				}else {
					/* Fields only for Automation */
				formattedData.u_app_host_machine_name = incidentDetails._source.app_host_machine_nm;
				formattedData.u_sessionid = incidentDetails._source.session_number;
				formattedData.startTime = getFormattedTime(incidentDetails._source.automata_start_time); // check automata_start_time
				formattedData.endTime = getFormattedTime(incidentDetails._source.automata_end_time); // check automata_end_time
				formattedData.resolutionMode = incidentDetails._source.resolution_mode;
				formattedData.exceptionClass = incidentDetails._source.exception_class_suggested;
				/* Fields only for Automation */
				formattedData.creationTime = getFormattedTime(incidentDetails._source.inc_created_at); //automata_create_time
				formattedData.u_jobid = incidentDetails._source.job_id;
				formattedData.u_client = incidentDetails._source.party_name; 
				formattedData.u_technology = incidentDetails._source.technology_name;
				formattedData.u_process_name = incidentDetails._source.srvc_prc_name;
				formattedData.processName = incidentDetails._source.srvc_prc_name;
				formattedData.u_process_id = incidentDetails._source.automata_busn_key;   // check           "automata_busn_key" : "E8CAF937-6306-49B3-9746-2D434F18B0A8",
				formattedData.franchise = incidentDetails._source.acct_type_name;
				formattedData.sysTime = getFormattedTime(incidentDetails._source.incident_updated_timestamp); // check last_update_time
				formattedData.u_resource = incidentDetails._source.automata_exe_resource; // check automata_exe_resource
				formattedData.automataName = incidentDetails._source.automata_name;
                if(alertType === "queueAlert"){
                    formattedData.u_resource = incidentDetails._source.resource;
                    formattedData.u_technology = incidentDetails._source.tclgy_nm;
                    formattedData.u_client = incidentDetails._source.party_nm;
                }
                /* Fields used for props to tabs */
				formattedData.ticketingToolPath = incidentDetails._source.incident_url;
				formattedData.aiopsInfo = incidentDetails._source.aiops ? incidentDetails._source.aiops : '';
				formattedData.selectedEntity = incidentDetails._source.entity ? incidentDetails._source.entity : '';
				/* Fields used for props to tabs */


				}
            }
            else if (workspace === workspaces.custom_ops) {
                if (incidentDetails._source) {
                    formattedData.u_jobid = incidentDetails._source.alert.id ? incidentDetails._source.alert.id : '';
                    formattedData.u_client = incidentDetails._source.metadata.clientId ? incidentDetails._source.metadata.clientId : '';
                    formattedData.u_technology = incidentDetails._source.tech ? incidentDetails._source.tech : '';
                    formattedData.u_process_name = incidentDetails._source.alert.name ? incidentDetails._source.alert.name : '';
                    formattedData.processName = incidentDetails._source.alert.name ? incidentDetails._source.alert.name : '';
                    formattedData.u_process_id = incidentDetails._source.entity;   // check automata_busn_key
                    formattedData.sysTime = getFormattedTime(incidentDetails.incident_updated_at ? incidentDetails.incident_updated_at : '');
                    formattedData.u_resource = incidentDetails._source.source.provider; // check automata_exe_resource
                    formattedData.creationTime = getFormattedTime(incidentDetails.incident_created_at); //automata_create_time
                    formattedData.franchise = incidentDetails._source.metadata.accType;
                    /* Fields used for props to tabs */
                    formattedData.ticketingToolPath = incidentDetails._source.incident.url ? incidentDetails._source.incident.url : '';
                    formattedData.aiopsInfo = incidentDetails._source.aiops ? incidentDetails._source.aiops : '';
                    formattedData.selectedEntity = incidentDetails._source.entity ? incidentDetails._source.entity : '';
                    formattedData.parentSystem = incidentDetails._source.parentSystem ? incidentDetails._source.parentSystem : '';
                    formattedData.entityType = incidentDetails._source.entityContext ? incidentDetails._source.entityContext : '';
                    formattedData.updatedTime = incidentDetails.incident_updated_at ? incidentDetails.incident_updated_at : '';
                    formattedData.business_service = incidentDetails._source.incident.businessService;
                    formattedData.startTime = getFormattedTime(incidentDetails._source.alert.time); // check automata_start_time
                    formattedData.sys_id = incidentDetails._source.incident.sysId;
                    formattedData.startTime = getFormattedTime(incidentDetails.work_start ? incidentDetails.work_start : ""); 
                    formattedData.endTime = getFormattedTime(incidentDetails.work_end ? incidentDetails.work_end : "");
                }
            }
            else {
					if(incidentDetails._source){
					formattedData.u_jobid = incidentDetails._source.job_id;
					formattedData.u_client = incidentDetails._source ? incidentDetails._source.partyName : client;
					formattedData.u_technology = incidentDetails._source.tech;
					formattedData.u_process_name = incidentDetails._source.alertName;
					formattedData.processName = incidentDetails._source.alertName;
					formattedData.u_process_id = incidentDetails._source.entity;   // check  automata_busn_key
					formattedData.sysTime = getFormattedTime(incidentDetails._source.lastUpdateTime); // check incident_updated_timestamp
					formattedData.u_resource = incidentDetails._source.entityContext; // check automata_exe_resource
					formattedData.creationTime = getFormattedTime(incidentDetails._source.inc_created_at); //automata_create_time
					formattedData.franchise = incidentDetails._source.accTypeName;
					/* Fields used for props to tabs */
					formattedData.ticketingToolPath = incidentDetails._source.incident_url;
					formattedData.aiopsInfo = incidentDetails._source.aiops ? incidentDetails._source.aiops : '';
					formattedData.selectedEntity = incidentDetails._source.entity ? incidentDetails._source.entity : '';
                    formattedData.predicted_rc = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_fb ? incidentDetails._source.classification.user_fb.predicted_rc : null;
                    formattedData.predicted_owner = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_fb ? incidentDetails._source.classification.user_fb.predicted_owner : null;
                    formattedData.predicted_category = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_fb ? incidentDetails._source.classification.user_fb.predicted_category :null;
                    formattedData.actionable = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_fb ? incidentDetails._source.classification.user_fb.actionable :null;
                    formattedData.tickettype = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_fb ? incidentDetails._source.classification.user_fb.tickettype : null;
                    formattedData.action = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_fb ? incidentDetails._source.classification.user_fb.action : null;
                    formattedData.action_desc = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_fb ? incidentDetails._source.classification.user_fb.action_desc : null;
                    formattedData.predicted_rc_feedback = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_suggested ? incidentDetails._source.classification.user_suggested.predicted_rc : null;
                    formattedData.predicted_owner_feedback = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_suggested ? incidentDetails._source.classification.user_suggested.predicted_owner : null;
                    formattedData.predicted_category_feedback = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_suggested ? incidentDetails._source.classification.user_suggested.predicted_category :null;
                    formattedData.priority_feedback = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_suggested ? incidentDetails._source.classification.user_suggested.priority : null;
                    formattedData.actionable_feedback = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_suggested ? incidentDetails._source.classification.user_suggested.actionable :null;
                    formattedData.tickettype_feedback = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_suggested ? incidentDetails._source.classification.user_suggested.tickettype : null;
                    formattedData.action_feedback = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_suggested ? incidentDetails._source.classification.user_suggested.action : null;
                    formattedData.action_desc_feedback = incidentDetails._source && incidentDetails._source.classification && incidentDetails._source.classification.user_suggested ? incidentDetails._source.classification.user_suggested.action_desc : null;
					formattedData.parentSystem = incidentDetails._source.parentSystem ? incidentDetails._source.parentSystem : '';
					formattedData.entityType = incidentDetails._source.entityContext ? incidentDetails._source.entityContext : '';
					formattedData.updatedTime = incidentDetails._source.lastUpdateTime ? incidentDetails._source.lastUpdateTime : ''; 

                    if (workspace === workspaces.salesforce_ops) {
                        formattedData.startTime =getFormattedTime(incidentDetails.work_start ? incidentDetails.work_start : ""); 
                        formattedData.endTime = getFormattedTime(incidentDetails.work_end ? incidentDetails.work_end : "");
                        formattedData.creationTime =   getFormattedTime(incidentDetails.incident_created_at ? incidentDetails.incident_created_at : "");
                        formattedData.sysTime = getFormattedTime(incidentDetails.incident_updated_at ? incidentDetails.incident_updated_at : "");
                        formattedData.remediation_info = incidentDetails._source.remediation_info ? incidentDetails._source.remediation_info : null;
                    }
					if ((alertType === "Infra Alert" || alertType === "SecurityAlert") && incidentDetails._source) {
						formattedData.ticketingToolPath = incidentDetails._source.incident.url;
						formattedData.franchise = incidentDetails._source.metadata.accType;
						formattedData.u_client = incidentDetails._source.metadata.clientId;
                        formattedData.u_jobid = incidentDetails._source.alert.id;
						formattedData.sysTime = getFormattedTime(incidentDetails._source.incident.lastUpdtTime); // check incident_updated_timestamp
                        formattedData.business_service = incidentDetails._source.incident.businessService;
                        formattedData.u_process_name = incidentDetails._source.alert.name;
                        formattedData.processName = incidentDetails._source.alert.name;
                        formattedData.u_resource = incidentDetails._source.source.provider; // check automata_exe_resource
                        formattedData.startTime = getFormattedTime(incidentDetails._source.alert.time); // check automata_start_time
                        formattedData.creationTime = getFormattedTime(incidentDetails._source.incident.createdAt); //automata_create_time
                        formattedData.sys_id = incidentDetails._source.incident.sysId;
                        formattedData.updatedTime =incidentDetails._source.incident.lastUpdtTime ? incidentDetails._source.incident.lastUpdtTime : '';
                        //formattedData.createdAt = incidentDetails._source.incident.createdAt;
					} 
					if (alertType === "sapone" && incidentDetails._source) {
						formattedData.ticketingToolPath = incidentDetails._source.incident_url;
						formattedData.franchise = incidentDetails._source.accType;
						formattedData.u_client = incidentDetails._source.clientId;
						formattedData.sysTime = getFormattedTime(incidentDetails._source.last_updt_time); // check incident_updated_timestamp
					} 


					}else {
                        if(client === "JandJ")
                        formattedData.u_client = client;

                    }
				

			}

		}
		console.log("formattedData",formattedData);
		return formattedData;
	};

	const updateDisableIncidentFlag = (response) => {
		if ((response.status === 299 || ['Resolved', 'Canceled', 'Closed'].includes(response.data.state))) {
			setDisableIncidentUpdate(true);
		} else {
			setDisableIncidentUpdate(false);
		}
	};

	const getIncidentDetails = async () => {
		let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(workspace);
		let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(workspace, client);
         
		let url = config.serverUrl + Constants.GETINCIDENTDETAILSURL + clientToSend + '/' + workspaceToSend + '/' + sysId;
		return await axios.get(url, {
			withCredentials: true,
			credentials: "include",
			headers: {
				'Content-Type': 'application/json'
			},
		}).then(response => {
			updateDisableIncidentFlag(response);
			return response;
		}).catch(error => {
			setIncidentDetailsLoading(false);
		});
	};

	const getIncidentDetailsForCustomFields = async () => {
		let bodyJSON = {
			"incidentId": incidentId,
			"workspace": workspace,
			"alertType": alertType,
			"partyName": client

		};
        if (window.location.pathname.indexOf('UserIncidentDetails') !== -1 && workspace === workspaces.salesforce_ops) {
            bodyJSON.status = "IncidentsUser";
        }

		return callPostApi(Constants.GETCUSTOMFIELDSFORINCIDENTDETAILS, {
			'Content-Type': 'application/json'
		}, bodyJSON)
			.then(response => {
				return response;
			}).catch(error => {
			});

	};


	const prepareUpdateIncidentPayload = (updatedIncidentData) => {
		let payload = {};
		let workNotes = "";

		if(updatedIncidentData){
			if((incidentDetailsData.predicted_rc !== "R" && updatedIncidentData.predicted_rc_feedback) || (incidentDetailsData.predicted_owner !== "R" && updatedIncidentData.predicted_owner_feedback) || (incidentDetailsData.predicted_category !== "R" && updatedIncidentData.predicted_category_feedback) || (incidentDetailsData.actionable !== "R" && updatedIncidentData.actionable_feedback) || (incidentDetailsData.action !== "R" && updatedIncidentData.action_feedback) || (incidentDetailsData.action_desc !== "R" && updatedIncidentData.action_desc_feedback)){
				workNotes = "User: " + user + "\n";
			}

         if(incidentDetailsData.predicted_rc !== "R" && updatedIncidentData.predicted_rc_feedback){
			 workNotes = workNotes.concat(" Probable root cause recomendation: Rejected"+ "\n" +" Suggestion: " + updatedIncidentData.predicted_rc_feedback);
		 } if(incidentDetailsData.predicted_owner !== "R" && updatedIncidentData.predicted_owner_feedback){
			workNotes = workNotes.concat(" Assignment group recomendation: Rejected"+ " Suggestion: " + updatedIncidentData.predicted_owner_feedback);
		 } if(incidentDetailsData.predicted_category !== "R" && updatedIncidentData.predicted_category_feedback){
			workNotes = workNotes.concat(" Category recomendation: Rejected"+ " Suggestion: " + updatedIncidentData.predicted_category_feedback);
		 } if(incidentDetailsData.actionable !== "R" && updatedIncidentData.actionable_feedback){
			workNotes = workNotes.concat(" Remediation Type recomendation: Rejected"+ " Suggestion: " + updatedIncidentData.actionable_feedback);
		 } if(incidentDetailsData.action !== "R" && updatedIncidentData.action_feedback){
			workNotes = workNotes.concat(" Action recomendation: Rejected"+ " Suggestion: " + updatedIncidentData.action_feedback);
		 } if(incidentDetailsData.action_desc !== "R" && updatedIncidentData.action_desc_feedback){
			workNotes = workNotes.concat(" Remediation Steps recomendation: Rejected"+ " Suggestion: " + updatedIncidentData.action_desc_feedback);
		 } 
		}

		if (updatedIncidentData) {
			console.log("updatedIncidentData",updatedIncidentData);
            let workNotesText = workNotes ? workNotes : undefined;
            let reasonToUpdate = UpdateReason.current ? UpdateReason.current : undefined;
			payload = {
				"contact_type": (updatedIncidentData.contact_type.id ? updatedIncidentData.contact_type.id : undefined),
				"assigned_to": updatedIncidentData.assigned_to.label,
				"assignment_group": updatedIncidentData.assignment_group.label,
				"category": updatedIncidentData.category.id || updatedIncidentData.category.label,
				"subcategory": updatedIncidentData.subcategory.id || updatedIncidentData.subcategory.label,
				"incident_id": updatedIncidentData.number ,
				"incident_state": (updatedIncidentData.state.id ? updatedIncidentData.state.id : undefined),
				"impact": (updatedIncidentData.impact.id ? updatedIncidentData.impact.id : undefined),
				"urgency": (updatedIncidentData.urgency.id ? updatedIncidentData.urgency.id : undefined),
				"work_notes":(workspace === workspaces.custom_ops  ? reasonToUpdate : workNotesText),
				"action_taken_by_soc": (updatedIncidentData.actionTakenBySOC && updatedIncidentData.actionTakenBySOC.id ? updatedIncidentData.actionTakenBySOC.id : undefined),
				"can_be_resolved_by_soc": (updatedIncidentData.resolvedBySOC && updatedIncidentData.resolvedBySOC.id ? updatedIncidentData.resolvedBySOC.id : undefined),
			    "priority_upgrade_reason": (updatedIncidentData.reasonsToUpgrade && updatedIncidentData.reasonsToUpgrade.id ? updatedIncidentData.reasonsToUpgrade.id : undefined),
                "priority_downgrade_reason": (updatedIncidentData.reasonsToDowngrade && updatedIncidentData.reasonsToDowngrade.id ? updatedIncidentData.reasonsToDowngrade.id : undefined),
                "accTypeName": (updatedIncidentData.franchise ? updatedIncidentData.franchise : undefined),
				"partyName": (updatedIncidentData.u_client ? updatedIncidentData.u_client : undefined),
				"entity": (updatedIncidentData.u_process_id ? updatedIncidentData.u_process_id : undefined),
				"alertName": (updatedIncidentData.u_process_name ? updatedIncidentData.u_process_name : undefined),


            }
            //console.log(payload,"payload")
		}

		return  JSON.stringify(payload);
	};

	const updateClassificationData = (updatedIncidentData) => {
        let bodyJSON = {
            "incident_id": updatedIncidentData.number,
            "user_fb": {
                'predicted_category': updatedIncidentData.predicted_category,
                'predicted_owner': updatedIncidentData.predicted_owner,
                'predicted_rc': updatedIncidentData.predicted_rc,
                'actionable': updatedIncidentData.actionable,
                'action': updatedIncidentData.action,
                'action_desc': updatedIncidentData.action_desc,
            },
            "user_suggested": {
                'predicted_category': updatedIncidentData.predicted_category_feedback,
                'predicted_owner': updatedIncidentData.predicted_owner_feedback,
                'predicted_rc': updatedIncidentData.predicted_rc_feedback,
                'actionable': updatedIncidentData.actionable_feedback,
                'action': updatedIncidentData.action_feedback,
                'action_desc': updatedIncidentData.action_desc_feedback
            }
        }
        callPostApi(Constants.GETCLASSIFICATIONSTATUS, {
            'Content-Type': 'application/json'
        }, bodyJSON).then(response => {
            fetchIncidentDetailsFromElasticAndITSM();
        });
	};
 

	const updateIncident = async (updatedIncidentData) => {
        if(updatedIncidentData.state && updatedIncidentData.state.label === "Resolved"){
			setNotifyResolve(true);
		}
        // else if (workspace === workspaces.custom_ops && (updatedIncidentData.reasonsToUpgradeDowngrade === undefined || (updatedIncidentData.reasonsToUpgradeDowngrade && updatedIncidentData.reasonsToUpgradeDowngrade.label === '')) && isReasonDropdownShown === true) {
		// 	setReasonError(true);
        // }
        else{
			let bodyJSON = prepareUpdateIncidentPayload(updatedIncidentData);

			let clientCheck = client;

			setIncidentUpdateLoading(true);
			setUpdateIncidentStatusMessage(null);

			if (clientCheck.toLowerCase().includes("omv")  && bodyJSON.assignment_group === undefined || bodyJSON.assignment_group === "") {
				setUpdateIncidentStatusMessage("Assignment group is Mandatory");
				setShowIncidentUpdateModal(true);
				setIncidentUpdateLoading(false);
				return;
			}
		
			let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(workspace);
			let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(workspace, client);
			let url = Constants.UPDATEINCIDENTURL + '/' + clientToSend + '/' + workspaceToSend + '/' + sysId;
			callPostApi(url, {
				'Content-Type': 'application/json'
			}, bodyJSON).then(response => {
				if (response === 403) {
					setUpdateIncidentStatusMessage(InsufficientPriviledge);
				} else {
					setUpdateIncidentStatusMessage(IncidentUpdated);
				}
				setShowIncidentUpdateModal(true);
				setIncidentUpdateLoading(false);
                updateClassificationData(updatedIncidentData);
				if(classificationData){
					updateClassificationData(updatedIncidentData);
				}else {
					fetchIncidentDetailsFromElasticAndITSM();
				}
	
			}).catch(error => {
				setUpdateIncidentStatusMessage(SomethingWentWrongError);
				setShowIncidentUpdateModal(true);
				setIncidentUpdateLoading(false);
			});
            //setReasonError(false);
		}
		
	};

	const toggleIncidentUpdateModal = () => {
		setShowIncidentUpdateModal(!showIncidentUpdateModal);
	};

    const toggleInsightModal = () => {
        setShowInsightModal(!showInsightModal);
    };

    const handleReason = (reason) => {
        UpdateReason.current = reason;
        //setReasonToUpdate(reason);
    }

	return (
		<div className="incident-details-page top-margin">
			{(incidentUpdateLoading || incidentDetailsLoading) && <Loading withOverlay={true} small={true} />}
			<Modal
				passiveModal
				open={showIncidentUpdateModal}
				onRequestClose={toggleIncidentUpdateModal}
				onRequestSubmit={toggleIncidentUpdateModal}
			>
				<p>{updateIncidentStatusMessage}</p>
			</Modal>
			{notifyResolve &&
			<div>
                  <InlineNotification 
                    kind="error"
                    subtitle={<span>{Mandatoryfields}</span>}
                    title="Resolution needed"
                    onCloseButtonClick={()=>notifyResolveError()}
                  />
                </div>}
            {/* {reasonError &&
                <div>
                    <InlineNotification
                        kind="error"
                        // subtitle={<span>{Mandatoryfields}</span>}
                        lowContrast={false}
                        title="Reason for Upgrade/Downgrade needed"
                        onCloseButtonClick={() => notifyReasonError()}
                    />
                </div>} */}
			<IncidentDetailsForm incidentDetailsData={incidentDetailsData} incidentDetailsDataForCompare={incidentDetailsDataForCompare} sysId={sysId} alertType={alertType} workspace={workspace}
				incidentDetailsLoading={incidentDetailsLoading} updateIncident={updateIncident}
				disableIncidentUpdate={disableIncidentUpdate}
				getIncidentDetails={fetchIncidentDetailsFromElasticAndITSM} handleReason={handleReason} Queue={queue} IncidentQueue={incidentQueue} QueueName={queueName} AppHostMachineName = {appHostMachineName}
                //handleIsReasonDropdownShown={handleIsReasonDropdownShown} 
			/>
            {showInsightModal &&
                <InsightsModal insightCarousalRows={insightsData} insightTableRows={insightsTableData} CarouselIndex={CarouselIndex}
                insightsTableHeaders={InsightsData.InsightsHeaders} showInsightModal={showInsightModal} handleCarouselSelect={handleCarouselSelect}
                toggleInsightModal={toggleInsightModal} insightsDataLoading={insightsDataLoading} insightsCount={insightsCount} handleInsightsUpdate={handleInsightsUpdate}
                getAcknowledgeData={getAcknowledgeData} />
            }
            {/* uncomment for insights section */}
            {insightsTableData.length > 0 && (configConst.URL.includes(configConst.staging) || configConst.URL.includes(configConst.development) || configConst.URL.includes(configConst.local)) &&
            <Button className="do-notification insight" iconDescription='Insights' onClick={toggleInsightModal} renderIcon={Idea32}>
                <span className='text'>{Insights}</span>
                {insightsData.filter(val => val.seen !== true).length > 0 ?
                    <span className="circle"> {insightsData.filter(val => val.seen !== true).length}</span>
                    :
                    ''
                }
            </Button>} 
		</div>
	);
};

export default IncidentDetailsPage;